import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import RTButton from '../common/RTButton';
import ViewClosedComplaints from './ViewClosedComplaints';
import 'bootstrap/dist/css/bootstrap.min.css';
import './ComplaintManagement.css';
import RTPageLayout from '../common/RTPageLayout';

const ViewComplaintsHistory = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return (
    <RTPageLayout
      activePath={location.pathname}
      title="Complaints History"
      actions={
        <>
          <RTButton variant="secondary" onClick={() => navigate(-1)}>
            ← Back
          </RTButton>
        </>
      }
      mainSection={true}
    >
      <ViewClosedComplaints loadData={true} />
    </RTPageLayout>
  );
};

export default ViewComplaintsHistory;
